import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'leafSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M92.3,227.7c8.3-10.3,7.1-18.8,7.6-22.1c0.6-3.4-1.7-12.3-1.7-12.3s-15-12.8-21.4-29.7
	c-6.3-16.4-10.2-29.8-10.2-47.9c0-18.6,7.3-28.2,9.6-34.9s10.2-19.4,16-28.4c3.2-4.9,7.9-11,1.2-18.9c-4.4-5.2-15.2-3.9-15.2-3.9
	s-2.3-6.8,7.9-7.9c10.1-1.1,30.4,8.2,37.7,13.5c12.4,9,27.3,23,33.2,32.1c9.6,14.6,13.9,37.2,14.5,47.9s-1.5,31.5-7.7,41.7
	c-3,4.9-15.1,22.7-15.1,22.7s3.9,3,10.6-5.3c4.5-5.6,14.1-14.1,23.1-19.1c9-5.1,24.8-4.5,33.8,0s18,19.1,27.6,19.1s14.1-13,14.1-13
	s7.3-2.8,6.8,5.6c-0.6,8.4-10.1,24.2-15.8,31.5c-5.6,7.3-20.4,18.9-32.7,23.7c-12.4,4.8-28.7,4.5-43.4-1.1
	c-9.7-3.7-18.6-9-24.8-11.3s-15.2-3.9-21.7,0c-3,1.8-9.5,20.8-9.5,20.8s-10.5,22.6-21.2,23.7S78.2,243,78.2,243
	S88.7,232.2,92.3,227.7z M136.7,170.2c5.6-10.6,7.3-15.8,10.2-28.2c2.4-9.9,2-23.7,1-36c-0.7-7.9-4.7-21.8-9.4-31
	c-4.2-8.1-16.3-14.6-13-11.8s7.8,20.1,9.1,29.8c2.1,15.8,0,30.1,0,43.4c0,14.1-6.2,32.1-8.2,38.9c-2,6.8,0,12.4,0,12.4
	S133.5,176.2,136.7,170.2z M170.8,177.2c0,0,10.9,1.6,14.6,1.8c8.3,0.5,11.9,5.1,18,8.4c8.1,4.3,20.2,4.4,26.1,2.6
	c6-1.8,13.7-5.8,13.7-5.8l-8.8,0.6c0,0-8,1.6-13.9,0.5c-5.9-1.2-8-4.7-18.8-9.1c-9.8-4-16.8-4.4-19.5-3.8
	C179.6,173,170.8,177.2,170.8,177.2z"
    />
  </svg>
);

export default SVG;
